<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">{{ title }}</h5>
            <p class="card-text">{{ description }}.</p>
            <router-link to="/contacto" class="btn btn-primary">Contactar</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            title: String,
            description: String
        }
    }
</script>